import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  BumpOptionDto,
  BumpOptionDtoSvcVas,
  BumpOptionModel,
  BumpOptionResp,
  BumpOptionsRespSvcVas,
  BumpOptionsDto,
  BumpOptionsDtoSvcVas,
  BumpOptionsModel,
  BumpOrderItemDto,
  BumpOrderItemDtoSvcVas,
  BumpOrderItemModel,
  MultiBumpDiscountDto,
  MultiBumpDiscountModel,
} from '../types/bump-options'
import { transformCurrencyAmountDto, transformCurrencyDto } from './currency'

export const transformBumpOrderItem = (dto: BumpOrderItemDto): BumpOrderItemModel => ({
  itemId: dto.item_id,
  title: dto.title,
  imageUrl: dto.image_url,
  totalPrice: transformCurrencyAmountDto(dto.total),
  discountedPrice: transformCurrencyAmountDto(dto.discounted),
})

export const transformBumpOption = (dto: BumpOptionDto): BumpOptionModel => ({
  id: `${dto.days}${dto.international ? '-int' : ''}`,
  days: dto.days,
  isDefault: dto.default,
  description: dto.description,
  isBestValue: dto.best_value,
  international: dto.international,
  countries: dto.countries,
  discountedPrice: transformCurrencyAmountDto(dto.discounted),
  isSalesTaxApplicable: dto.sales_tax_applicable,
  bumpOrderItems: dto.push_up_order_items.map(transformBumpOrderItem),
})

export const transformMultiBumpDiscount = (dto: MultiBumpDiscountDto): MultiBumpDiscountModel => ({
  minPaidItemCount: dto.min_paid_item_count,
  discountPercentage: dto.discount_percentage,
})

export const transformBumpsOptions = (dto: BumpOptionsDto): BumpOptionsModel => ({
  freeBumpsCount: dto.free_push_ups_count,
  hasLocalOptions: dto.has_local_options,
  bumpableItemCount: dto.bumpable_item_count,
  discountPercentage: dto.discount_percentage,
  multiBumpDiscount: transformMultiBumpDiscount(dto.multi_bump_discount),
  options: dto.options ? dto.options.map(transformBumpOption) : [],
})

export const transformBumpOptionsResponse = (response: Response<BumpOptionResp>) =>
  transformBumpsOptions(response)

export const transformBumpOrderItemSvcVas = (dto: BumpOrderItemDtoSvcVas): BumpOrderItemModel => ({
  itemId: dto.item_id,
  title: dto.title,
  imageUrl: dto.image_url,
  totalPrice: transformCurrencyDto(dto.total_price),
  discountedPrice: transformCurrencyDto(dto.discounted_price),
})

export const transformBumpOptionSvcVas = (dto: BumpOptionDtoSvcVas): BumpOptionModel => ({
  id: `${dto.days}${dto.international ? '-int' : ''}`,
  days: dto.days,
  countries: dto.countries,
  isDefault: dto.default,
  description: dto.description,
  isBestValue: dto.best_value,
  international: dto.international,
  bumpOrderItems: dto.bump_order_items.map(transformBumpOrderItemSvcVas),
  discountedPrice: transformCurrencyDto(dto.discounted_price),
  isSalesTaxApplicable: dto.sales_tax_applicable,
})

export const transformBumpsOptionsSvcVas = (dto: BumpOptionsDtoSvcVas): BumpOptionsModel => ({
  freeBumpsCount: dto.free_bumps_count,
  hasLocalOptions: dto.has_local_options,
  bumpableItemCount: dto.bumpable_item_count,
  discountPercentage: dto.discount_percentage,
  multiBumpDiscount: transformMultiBumpDiscount(dto.multi_bump_discount),
  options: dto.options ? dto.options.map(transformBumpOptionSvcVas) : [],
})

export const transformBumpOptionsResponseSvcVas = (response: Response<BumpOptionsRespSvcVas>) =>
  transformBumpsOptionsSvcVas(response)
